import { injectIntl } from "react-intl";
import loadable from "./loadable";

export default injectIntl(loadable);
